import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestCNInvoiceList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/credit-note/invoiceList`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/credit-note/invoiceList?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestGeneratedCreditNoteList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/credit-note`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/credit-note?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestDraftCreditNoteList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/credit-note`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/credit-note?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function createCrediNote(params) {
  return fetch.post(`${BASE_URL}/api/app/credit-note`, params);
}

export function deleteCreditNoteService(params) {
  return fetch.delete(
    `${BASE_URL}/api/app/credit-note/delete-credit-note/${params}`
  );
}

export function requestCreditNoteDetailList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/credit-note`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/credit-note?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function updateCreditNoteStage(params) {
  return fetch.put(`${BASE_URL}/api/app/credit-note/update/list`, params);
}

export function getCreditNoteInvoiceItem(parmas) {
  return fetch.get(
    `${BASE_URL}/api/app/credit-note/get-credit-note-items-invoice-items/${parmas}`
  );
}

export function editCreditNote(params) {
  return fetch.put(
    `${BASE_URL}/api/app/credit-note/update/credit-note`,
    params
  );
}
export function requestCreditNotePdf(params) {
  return fetch.post(`${BASE_URL}/api/app/credit-note/generatePdf`, {
    ...params,
  });
}
export function generateEcreditNote(body) {
  return fetch.post(`${BASE_URL}/api/app/external-api/generateIRN`, body);
}

export function cancelCreditNote(params) {
  return fetch.post(`${BASE_URL}/api/app/external-api/cancelEinvoice`, params);
}
export function requestmissedCreditNote(params) {
  return fetch.get(`${BASE_URL}/api/app/credit-note/missedCreditNote`, {
    params: params,
  });
}
export function requestBusinessCenter(params) {
  return fetch.get(`${BASE_URL}/api/app/credit-note/businessCenterList`, {
    params: params,
  });
}
export function requestFiniancialCreditNote(params) {
  return fetch.put(`${BASE_URL}/api/app/credit-note/finiancialCreditNote`, {
    ...params,
  });
}
